import { DotsThreeVertical } from "@phosphor-icons/react";

import DesktopActions from "common/components/DesktopActions";
import { Button } from "common/components/ui/Button";
import type { Member } from "common/types";

import useMembersActions from "../../../hooks/useMembersActions";
import MemberActions from "../MemberActions";

interface MemberActionsDropdownProps {
  member: Member;
}

export default function MemberActionsDropdown({
  member,
}: MemberActionsDropdownProps) {
  const { actions } = useMembersActions(member);

  if (!Object.keys(actions).length) {
    return null;
  }

  return (
    <DesktopActions
      triggerElement={
        <Button intent="iconOnly" variant="secondary-black" size="sm">
          <DotsThreeVertical />
        </Button>
      }
      editOptions={actions}
    >
      {(action, onClose) => (
        <MemberActions
          action={action}
          member={member}
          onClose={onClose}
          onBack={onClose}
        />
      )}
    </DesktopActions>
  );
}
